export const PerformanceGradeValues = ['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'CCC'] as const

export type PerformanceGrade = (typeof PerformanceGradeValues)[number]

export function gradeRank(grade: PerformanceGrade | null | undefined): number {
  return grade ? PerformanceGradeValues.indexOf(grade) : PerformanceGradeValues.length
}

/**
 * Maps a composite performance score (0-10) to a letter grade.
 */
export function compositeScoreToGrade(composite: number): PerformanceGrade {
  if (composite >= 9.5) {
    return 'AAA'
  }
  if (composite >= 9) {
    return 'AA'
  }
  if (composite >= 8.25) {
    return 'A'
  }
  if (composite >= 7.25) {
    return 'BBB'
  }
  if (composite >= 6.25) {
    return 'BB'
  }
  if (composite >= 5.25) {
    return 'B'
  }
  return 'CCC'
}
